import React, {useCallback, useContext, useEffect, useState} from 'react';
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {useTheme} from "@mui/styles";
import {useForm} from "react-hook-form";
import {AppContext} from "../../../App";
import {
	Backdrop,
	Button, Checkbox,
	CircularProgress, DialogActions,
	DialogContentText,
	Divider, FormControlLabel,
	Menu,
	MenuItem,
	Paper,
	Typography
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {langDict, languages} from "../../../strings/LanguageDictionary";
import IconButton from "@mui/material/IconButton";
import {setCloseSnackbar, setLang, setOpenSnackbar, setThemeType} from "../../../services/AppServices";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import GTranslateTwoToneIcon from "@mui/icons-material/GTranslateTwoTone";
import clsx from "clsx";
import Background from "../../../assets/Ocean-bg.jpg";
import Grid from "@mui/material/Grid";
import {
	bigNoteRegisterRequired,
	codFRegister, cognomeRegister, emailRegister, nomeRegister, phoneRegister,
} from "../../../utils/RegisterUtils";
import CustomText from "../../widgets/inputs/CustomText";
import Copyright from "../../auth/utils/Copyright";
import Snackbar from "@mui/material/Snackbar";
import SimpleDialog from "../../widgets/dialogs/SimpleDialog";
import { Alert, AlertTitle } from '@mui/material';
import CustomSelect from "../../widgets/inputs/CustomSelect";
import CustomMultiText from "../../widgets/inputs/CustomMultiText";
import axios from "axios";
import {BASE_NAME} from "../../../services/utils/ApiUrls";
import {capitalizeWords} from "../../../utils/GenericUtils";
import {getErrorMessage} from "../../../reducers/utils/ReducerUtils";

const VacciniPreferences = () => {
	const contattaciClasses = ContattaciStyle();
	const classes = BaseStyle();
	let theme = useTheme();
	const {control, handleSubmit, errors, watch, register} = useForm({mode: "onChange",});
	
	const [openInformativa, setOpenInformativa] = useState(true);
	const [read, setRead] = useState(false);
	const [submit, setSubmit] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [checked, setChecked] = useState(false);
	const [checkedOk, setCheckedOk] = useState(false);
	
	const appContext = useContext(AppContext);
	
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	
	const handleClose = (key) => {
		if (key) {
			setLang(key, appContext.dispatch)
		}
		setAnchorEl(null);
	};
	
	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		console.log(data);
		
		axios
			.post(BASE_NAME + 'vaccinazioni/generateAdesione', {
				...data,
				codF: data.codF?.toUpperCase(),
				nome: capitalizeWords(data.nome),
				cognome: capitalizeWords(data.cognome),
			})
			.then(() => {
				setOpenSnackbar('success', 'La tua adesione è stata ricevuta con successo! Ora puoi chiudere questa scheda.', appContext.dispatch);
				setTimeout(() => window.location.reload(), 2000);
			})
			.catch((error) => {
				let errorMessage = getErrorMessage(error);
				if (errorMessage === '#DUPLICATE-CODF-ERROR') {
					setOpenSnackbar('error', 'Hai già effettuato una richiesta di adesione', appContext.dispatch)
				} else {
					setOpenSnackbar('error', 'Ops, qualcosa è andato storto, riprova...', appContext.dispatch);
				}
			})
			.finally(() => setSubmit(false));
	}, [appContext.dispatch])
	
	const checkCodf = useCallback(() => {
		let codF = watch('codF');
		if (!codF) return;
		
		setSubmit(true)
		
		axios
			.get(BASE_NAME + 'vaccinazioni/adesioneCheck/' + codF.toUpperCase())
			.then(() => {
				setChecked(true);
				setCheckedOk(true)
			})
			.catch(() => {
				setChecked(true);
				setCheckedOk(false)
			})
			.finally(() => setSubmit(false))
	}, [watch]);
	
	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
        <React.Fragment>
            <Backdrop open={submit} className={classes.backdrop} style={{zIndex: 6000}}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
            <main className={classes.mainNoBgCol}>
				<header className={contattaciClasses.header}>
					<Tooltip
						title={appContext.state.theme.palette.mode === "light" ? languages[appContext.state.lang].OCEAN__MAIN_GLOBAL_THEMA_TEXT : languages[appContext.state.lang].OCEAN__GLOBAL_THEMA_TEXT_DARK}>
						<IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
								appContext.state.theme, appContext.dispatch)}
                            size="large">
							{
								appContext.state.theme.palette.mode === "light" ?
									<Brightness4TwoToneIcon/> :
									<Brightness5TwoToneIcon/>
							}
						</IconButton>
					</Tooltip>
					<Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
						<Button
							className={contattaciClasses.translateButton}
							color="inherit"
							style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000", borderRadius: 24}}
							onClick={handleClick}
							startIcon={<GTranslateTwoToneIcon/>}
						>
							{languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
						</Button>
					</Tooltip>
					<Menu
						PaperProps={{
							className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
						}}
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={() => handleClose()}
					>
						{
							Object.entries(langDict).map(([key, val]) => {
								return (
									<MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
										style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
								)
							})
						}
					</Menu>
					<Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
						<b>Aderisci alla vaccinazione</b>
					</Typography>
				</header>
				
				<article className={contattaciClasses.article}>
					<Paper
						className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
						<form onSubmit={handleSubmit(onSubmit)}>
							<Grid container spacing={3}>
								
								<Grid item xs={12}>
									<Alert severity={"warning"} style={{
										borderRadius: 22,
										lineHeight: 1.8
									}}>
										<AlertTitle><strong>QUARTA DOSE (O SECONDO “BOOSTER”) per cittadini over 12</strong></AlertTitle>
										Le nuove disposizioni ministeriali prevedono il via libera alla quarta dose con il nuovo vaccino
										bivalente per tutti i cittadini con almeno 12 anni compiuti a condizione che siano trascorsi almeno
										120 giorni dall’ultima somministrazione.<br/>
										I cittadini over 60 saranno presi in carico direttamente dalla ASL mentre chi ha un’età compresa tra
										i 12 e i 59 anni verrà convocato presso uno dei centri vaccinali dopo aver effettuato la preadesione
										su <a href={'https://www.ilpiemontetivaccina.it/preadesione/#/'} target={"_blank"}
										      rel={'noreferrer'}>www.ilpiemontetivaccina.it</a>. Sarà sempre possibile prenotare
										l’appuntamento di vaccinazione presso
										le farmacie aderenti o presso il proprio medico se vaccinatore.<br/>
										Le donne in gravidanza che desiderano ricevere la quarta dose potranno recarsi ad accesso diretto
										presso un centro vaccinale del territorio.<br/>
										<br/>
										<strong style={{fontSize: 26}}>A partire da Lunedì 3 ottobre questo portale non sarà più il canale
											corretto per manifestare
											la propria adesione.<br/>
											Per indicare la propria adesione bisognerà proseguire su: <a
												href={'https://www.ilpiemontetivaccina.it/preadesione/#/'} target={"_blank"}
												rel={'noreferrer'}>www.ilpiemontetivaccina.it</a>.<br/>
											Per gli over 60 verrà inviata via SMS una proposta di appuntamento nei prossimi giorni.
										</strong>
									</Alert>
								</Grid>
								
								<Grid item xs={12}>
									<Typography>
										<b>Dati anagrafici</b>
									</Typography>
									<Typography color={"textSecondary"}>
										Compila in modo coretto i dati che sono riportati qui sotto. Utilizza un email ed un numero di
										telefono validi in quanto questi verranno utilizzati per comunicarti l'effettiva convocazione.
									</Typography>
								</Grid>
								
								<Grid item xs={12}>
									<CustomText
										control={control}
										disabled={true}
										rules={codFRegister}
										name={"codF"}
										label={languages[appContext.state.lang].ANAGRAFICA__CODICE__FISCALE__ + "*"}
										autoFocus={false}
										inputProps={{
											className: classes.input
										}}
										type={"text"}
										error={errors["codF"]}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<CustomText
										control={control}
										rules={nomeRegister}
										disabled={true}
										name={"nome"}
										label={languages[appContext.state.lang].ANAGRAFICA__NAME_LBL + "*"}
										placeholder={"Giuseppe"}
										autoFocus={false}
										autoComplete={"given-name"}
										inputProps={{
											className: classes.capitalizeInput
										}}
										error={errors["nome"]}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<CustomText
										control={control}
										rules={cognomeRegister}
										disabled={true}
										name={"cognome"}
										label={languages[appContext.state.lang].ANAGRAFICA__SURNAME_ + "*"}
										placeholder={"Rossi"}
										autoFocus={false}
										autoComplete={"family-name"}
										inputProps={{
											className: classes.capitalizeInput
										}}
										error={errors["cognome"]}
									/>
								</Grid>
								<Grid item xs={12} sm={8}>
									<CustomText
										control={control}
										rules={emailRegister}
										disabled={true}
										name={"email"}
										label={languages[appContext.state.lang].ANAGRAFICA__EMAIL___ + "*"}
										autoFocus={false}
										placeholder={"rossi.giuseppe@gmail.com"}
										autoComplete={"email"}
										error={errors["email"]}
									/>
								</Grid>
								<Grid item xs={12} sm={4}>
									<CustomText
										control={control}
										rules={phoneRegister}
										disabled={true}
										name={"cellulare"}
										placeholder={"3333333333"}
										label={languages[appContext.state.lang].ANAGRAFICA__CELLULARE__1__LBL + "*"}
										autoFocus={false}
										error={errors["cellulare"]}
										autoComplete={"phone"}
									/>
								</Grid>
								
								<Grid item xs={12}>
									<Divider/>
								</Grid>
								
								{
									!checked &&
									<React.Fragment>
										<Grid item xs={12}>
											<Typography color={"textSecondary"}>
												Cliccando su verifica, se risulti un operatore sanitario potrai effettuare la preadesione,
												altrimenti ti verrà chiesto il tuo profilo contrattuale che verrà verificato in seguito.
											</Typography>
										</Grid>
										<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
											<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
											        onClick={checkCodf} disabled={true}
											        style={{fontSize: 18, borderRadius: 24}}>
												<b>Verifica i tuoi dati</b>
											</Button>
										</Grid>
									</React.Fragment>
								}
								
								{
									checked && !checkedOk &&
									<React.Fragment>
										<Grid item xs={12}>
											<Typography color={"textSecondary"}>
												Il tuo profilo non risulta come operatore sanitario. In caso tu sia un operatore sanitario
												indica
												nelle note qui sotto il tipo di profilo e la sede di lavoro. Un operatore verificherà i dati da
												te
												indicati e ti contatterà per fornirti spiegazioni.
											</Typography>
										</Grid>
										<Grid item xs={12}>
											<CustomMultiText
												inputRef={register(bigNoteRegisterRequired)}
												name={"extra1"}
												label={"Note *"}
												autoFocus={false}
												error={errors["extra1"]}
												rows={5}
											/>
										</Grid>
										<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
											<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
											        onClick={handleSubmit(onSubmit)} disabled={submit}
											        style={{fontSize: 18, borderRadius: 24}}>
												<b>Conferma la tua adesione</b>
											</Button>
										</Grid>
									</React.Fragment>
								}
								
								{checked && checkedOk && <React.Fragment>
									<Grid item xs={12}>
										<Typography color={"textSecondary"}>
											Indica una tra le preferenze proposte. Verrai poi contattato via SMS ed email per la comunicazione
											della data e del luogo effettivo.
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<CustomSelect
											name={"sede"}
											label={'Scegli la sede'}
											control={control}
											autoFocus={false}
											none={true}
											noneValue={""}
											rules={{required: true}}
											error={errors["sede"]}
										>
											<MenuItem value={'SGB'}>
												Ospedale San Giovanni Bosco
											</MenuItem>
											<MenuItem value={'LTT'}>
												Lingotto
											</MenuItem>
										</CustomSelect>
									</Grid>
									
									<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
										<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
										        onClick={handleSubmit(onSubmit)} disabled={submit}
										        style={{fontSize: 18, borderRadius: 24}}>
											<b>Conferma la tua adesione</b>
										</Button>
									</Grid>
								</React.Fragment>}
							</Grid>
						
						</form>
					</Paper>
				</article>
				
				<footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
					<Copyright/>
				</footer>
			</main>
            <Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<Alert style={{borderRadius: 28}} onClose={handleCloseSnack}
				       severity={appContext.state.severity}>
					{appContext.state.message}
				</Alert>
			</Snackbar>
            <SimpleDialog
				open={openInformativa}
				customFullScreen={true}
				title={languages[appContext.state.lang].CONTATTACI__BENVENUTO__TITLE_}
				content={
					<DialogContentText component={"div"}>
						{languages[appContext.state.lang].CONTATTACI_INFORMATIVA_PRIVACY}
						<a style={{color: theme.palette.primary.main}}
						   href={"http://www.aslcittaditorino.it/privacy/"}
						   target="_blank"
						   rel="noopener noreferrer">{
							"http://www.aslcittaditorino.it/privacy/"
						}</a> {languages[appContext.state.lang].CONTATTACI_INFORMATIVA_PRIV_2_}.<br/>
						<FormControlLabel
							control={
								<Checkbox
									color={"primary"}
									checked={read}
									onChange={() => setRead(!read)}
									name="read"/>
							}
							label={languages[appContext.state.lang].CONTATTACI_READ_CONFIRM_PRIV_}
						/>
					</DialogContentText>
				}
				actions={
					<DialogActions>
						<Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
							<Button
								color="inherit"
								style={{color: appContext.state.theme.palette.mode === "light" ? "#000" : "#FFF", borderRadius: 24}}
								onClick={handleClick}
								startIcon={<GTranslateTwoToneIcon/>}
							>
								{languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
							</Button>
						</Tooltip>
						<Menu
							PaperProps={{
								className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
							}}
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={() => handleClose()}
						>
							{
								Object.entries(langDict).map(([key, val]) => {
									return (
										<MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
											style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
									)
								})
							}
						</Menu>
						<Button variant={"contained"} disableElevation size={"small"} className={classes.roundButton}
						        color={"primary"} style={{borderRadius: 24}}
						        onClick={() => setOpenInformativa(false)} disabled={!read}>
							<b>{languages[appContext.state.lang].CONTATTACI__CONFERMO_PRIVACY_}</b>
						</Button>
					</DialogActions>
				}
			/>
        </React.Fragment>
    );
};

export default React.memo(VacciniPreferences);
